// extracted by mini-css-extract-plugin
export default {"home":"RegenerativeMedicinePage_home__p36GY","services":"RegenerativeMedicinePage_services__VC7lM"};